import React from 'react'
import Pt from 'prop-types'

const identity = i => i

/**
 * Wraps a component with a stateful React component that holds on
 * to its state until the component blurs.
 *
 * This is useful for controls like the Autocomplete, that we don't
 * want to fire the value until blur because of keyboard navigation
 * causing onChange events every keydown, which could close the
 * dropdown (since the first time an item is selected, the value changes
 * and the form no longer has the original typed value for the dropdown).
 *
 * Supply a toDisplay and/or fromDisplay to manipulate the value that goes
 * into or comes out of the wrapped component.
 */
export default function withValueState(
  WrappedComponent,
  toDisplay = identity,
  fromDisplay = identity,
) {
  return class ValueState extends React.Component {
    static displayName = `withValueState(${WrappedComponent.displayName || WrappedComponent.name})`
    static propTypes = {
      onBlur: Pt.func,
      onChange: Pt.func,
      // eslint-disable-next-line react/forbid-prop-types
      value: Pt.any,
    }

    state = {
      value: toDisplay(this.props.value),
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          value: toDisplay(nextProps.value),
        })
      }
    }

    onBlur = (e, data) => {
      const realVal = fromDisplay(this.state.value)
      if (this.props.onBlur && realVal !== this.props.value) {
        this.props.onBlur(e, data, realVal)
      }
    }

    onChange = (e) => {
      this.setState({
        value: e.target.value,
      })

      if (this.props.onChange) {
        this.props.onChange(e, fromDisplay(e.target.value))
      }
    }

    render() {
      const {
        /* eslint-disable no-unused-vars */
        onBlur,
        onChange,
        value,
        /* eslint-enable no-unused-vars */
        ...props
      } = this.props

      return (
        <WrappedComponent
          {...props}
          onBlur={this.onBlur}
          onChange={this.onChange}
          value={this.state.value}
        />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/Form/withValueState.jsx